'use client';
import { useQueryState, parseAsStringLiteral } from 'nuqs';
import { Button } from '@nf/ui';
import clsx from 'clsx';
import { styles } from './sidebar-category.style';
import { CasinoIcon, Icon } from '@/components/icons/svg-icons';
import { useSideBarContext } from '../../contexts/sidebar-context';
import { useTranslations } from 'next-intl';
import { useEffect, useRef } from 'react';
import { useAppearanceStore } from '@/store/appearance';
import { ViewEnum } from '@/types';

export const SidebarCategory = () => {
	const { selectedCategory, setSelectedCategory } = useSideBarContext();
	const t = useTranslations('General');
	const view = useAppearanceStore(state => state.view);
	
	const [category, setCategory] = useQueryState(
		'category', 
		parseAsStringLiteral(['Sports', 'Games'] as const)
	);
	const prevViewRef = useRef<ViewEnum | null>(null);

	const buttons = [
		{
			name: 'Sports',
			icon: <Icon name="sports" />,
		},
		{
			name: 'Games',
			icon: <CasinoIcon />,
		},
	]
	const changeSelected = (name: string) => {
		setSelectedCategory(name);
		setCategory(null);
	};

	useEffect(() => {
		if (prevViewRef.current !== null && prevViewRef.current !== view) {
			if (view === ViewEnum.galaxy) {
				setSelectedCategory('Sports');
			}
		}
		prevViewRef.current = view;
	}, [view, setSelectedCategory]);

	useEffect(() => {
		if (category) {
			setSelectedCategory(category);
		}
	}, [category, setCategory]);
	
	return (
		<div className={ view === ViewEnum.galaxy ? 'side-category' :styles.category}>
			{buttons.map(item => {
				return (
					<Button
						variant={(item.name === selectedCategory && view === ViewEnum.mars) ? 'primaryOutline' : 'classic'}
						onClick={() => changeSelected(item.name)}
						className={clsx('side-category__btn', { [styles.button]: view === ViewEnum.mars })}
						data-selected={item.name === selectedCategory}
						key={item.name}
					>
						{item.icon}
						<span className={clsx({ [styles.buttonText]: view === ViewEnum.mars })}>
							{item.name === 'Sports' ? t('lbl_MarsSports') : t('lbl_MarsGames')}
						</span>
					</Button>
				)
			})}
		</div>
	)
};